import {Box, Card, CardContent, TextField, Typography} from "@mui/material";

const TextInputField = ({textInput, onChange, isSubmitting}) => {
  return (
    <Card variant="outlined" sx={{height: "100%"}}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          📝 Texto Adicional
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Proporciona contexto adicional, instrucciones específicas o cualquier texto relevante
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={8}
          variant="outlined"
          placeholder="Escribe aquí cualquier texto adicional, instrucciones para la IA, o contexto relevante para el análisis..."
          value={textInput}
          onChange={onChange}
          disabled={isSubmitting}
        />
        <Box sx={{mt: 1, display: "flex", justifyContent: "space-between"}}>
          <Typography variant="caption" color="textSecondary">
            {textInput.length} caracteres
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Opcional
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TextInputField;
